import { render, staticRenderFns } from "./Create-Group.vue?vue&type=template&id=2e5c70a5&"
import script from "./Create-Group.vue?vue&type=script&lang=js&"
export * from "./Create-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports